import { SvgIcon } from '@material-ui/core'

export default function GalleryShowIcon(props: any) {
    return (
        <SvgIcon
            viewBox="0 0 24 24"
            fill="none"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <g transform="translate(24, 0) scale(-1, 1)">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill="none" stroke="currentColor" />
                <rect x="3" y="3" width="6" height="18" rx="2" ry="2" fill="currentColor" stroke="currentColor" />
                <path d="M13 8l4 4-4 4" stroke="currentColor" fill="none" />
            </g>
        </SvgIcon>
    )
}
